export default "__VITE_ASSET__BXWNJbqe__"